import { createGlobalStyle } from 'styled-components';

const Global = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    background-color: ${(p) => p.theme.alias.bg};
    color: ${(p) => p.theme.alias.fg};
    margin: ${(p) => p.theme.space[0]};
    font-size: 13px;
    font-weight: 400;
    font-family: ${(p) => p.theme.fonts.sans};
    line-height: 16px;
    overflow-x: auto;
    overflow-y: scroll;
  }

  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: ${(p) => p.theme.space[0]};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }

  button,
  input,
  select,
  textarea {
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
    background-color: transparent;
  }

  ol,
  ul {
    list-style: none;
    margin: ${(p) => p.theme.space[0]};
    padding: ${(p) => p.theme.space[0]};
  }

  a,
  button {
    color: inherit;
    cursor: default;
  }

  a,
  button,
  input,
  select,
  textarea {
    color: inherit;
    outline: none;
  }

  a {
    text-decoration: none;
  }

  button {
    border: none;
  }

  table {
    border-collapse: collapse;
  }

  th,
  td {
    padding: ${(p) => p.theme.space[0]};
  }
`;

export default Global;
